export default function (data: any) {
  return `cart${data?.site_type === 4 ? '-shop' : ''}${data?.locale ? `-${data?.locale}` : ''}${data?.currency ? `-${data?.currency}` : ''}`
}
